import(/* webpackMode: "eager", webpackExports: ["ResetPasswordForm"] */ "/vercel/path0/src/components/auth/ResetPasswordForm.tsx");
